import { GlobalController } from 'src/shared/global/GlobalController'
import GeneratorOrder from './GeneratorOrder'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: ':link',
    name: 'generateOrder',
    component: GeneratorOrder,
    beforeEnter: ifAuthenticated,
    props: true
  }
]
